import http from '../http.service'
import { BaseDataService } from '@/services/api/BaseDataService'

const BASE_ENTITY_URL = '/stop-list'

class StopListDataService extends BaseDataService {
  getActualList (filialId) {
    return this.http.get(`${this.baseEntityUrl}/actual`, {
      params: {
        filialId,
      },
    })
      .then((res) => res.data.items)
  }

  /**
   * @param $filialId
   * @param $menuItemId
   * @returns {Promise<AxiosResponse<any>>}
   */
  create ({ filialId, menuItemId, reason }) {
    return http.post(this.baseEntityUrl, { filialId, menuItemId, reason })
      .then(res => res.data.data)
  }

  delete ({ filialId, menuItemId }) {
    return http.delete(this.baseEntityUrl, { params: { filialId, menuItemId } })
      .then(res => res.data.data)
  }

  // Статус стопов филиала: { stopCount, filialStop: {stoppedAt, reason, reasonComment} | null }
  // responseSuccess бэка кладёт payload в корень ответа, не в data
  getStatus (filialId) {
    return this.http.get(`${this.baseEntityUrl}/status`, { params: { filialId } })
      .then((res) => res.data)
  }

  createFilialStop ({ filialId, reason, reasonComment }) {
    return http.post(`${this.baseEntityUrl}/filial-stop`, { filialId, reason, reasonComment })
      .then(res => res.data)
  }

  deleteFilialStop ({ filialId }) {
    return http.delete(`${this.baseEntityUrl}/filial-stop`, { params: { filialId } })
      .then(res => res.data)
  }
}

export default new StopListDataService(BASE_ENTITY_URL)
